<script>
	// Stores 
	import { textSite } from '../store.js';    

	// Componentes
	import { link } from "svelte-routing";
	import PageHeader from './../components/PageHeader.svelte';

	// Code
	let titlePage = 'Garantias Locatícias';    

</script>

<PageHeader title={titlePage}></PageHeader> 
<div class="container clearfix text-justify">

	<p>Confira as garantias que aceitamos para locação:</p>
	
	<div class="gridbox size--1 md-size--1">

		<hr>
		<div class="gridbox size--120-fr md-size--1 gap--10 xs-gap--v10">
			<div class="media-left flex-grid">
				<i class="color-accent fa-5x fas fa-credit-card"></i>
			</div>
			<div class="media-body">
				<h2 class="color-accent">CredPago</h2>
				<p>A CredPago é uma empresa que oferece o serviço de garantia locatícia para que inquilinos possam alugar imóveis sem fiador e sem burocracia.</p>
				<p>O valor da taxa é calculado 10% o valor do aluguel (anual)+ taxas e pode ser parcelado em até 12x.</p>
				<p>Se quiseres saber qual o valor da taxa para o imóvel que tu estás interessado, solicite pelo whatsapp do setor de aluguéis.</p>
				<p>Documentos: para a pré-avaliação somente enviar por whatsapp o seu nome completo, CPF, data de nascimento e e-mail.</p>
				<p>Obs: se não aprovar apenas com esses dados, poderá ser solicitado uma fatura de cartão de crédito em seu nome para entrar na análise. Ou também, poderá ser solicitado os dados de mais inquilinos.</p>
			</div>
		</div>

		<hr>
		<div class="gridbox size--120-fr md-size--1 gap--10 xs-gap--v10">
			<div class="media-left flex-grid">
				<i class="color-accent fa-5x fas fa-user-shield"></i>
			</div>
			<div class="media-body">
				<h2 class="color-accent">Fiador</h2>
				<p>É necessária a apresentação de 01 (um) fiador com 02 (dois) imóveis quitados, ou 02 (dois) fiadores com 01 (um) imóvel quitado cada, registrado(s) em nome do(s) fiador(es); não podendo estar em inventário nem com usufruto, e renda comprovada superior a 3x o valor do aluguel mais as taxas.</p>
			</div>
		</div>

		<hr>
		<div class="gridbox size--120-fr md-size--1 gap--10 xs-gap--v10">
			<div class="media-left flex-grid">
				<i class="color-accent fa-5x fas fa-shield-check"></i>
			</div>
			<div class="media-body">
				<h2 class="color-accent">Seguro Fiança</h2>
				<p>Essa modalidade de garantia é concedida mediante a aprovação de crédito junto à determinada seguradora. O valor dos encargos pode ser parcelado no boleto de aluguel até o final do contrato. Não é reembolsado ao final do contrato.</p>
			</div>
		</div>

		<hr>
		<div class="gridbox size--120-fr md-size--1 gap--10 xs-gap--v10">
			<div class="media-left flex-grid">
				<i class="color-accent fa-5x fas fa-file-invoice-dollar"></i>
			</div>
			<div class="media-body">
				<h2 class="color-accent">Título de Captalização</h2>
				<p>Consiste em uma aplicação financeira que corresponde de 6 (seis) a 12 (doze) vezes o valor do aluguel e encargos do imóvel a ser locado. O valor é depositado à vista e permanece durante a locação, sendo corrigido pela TR. Após entrega das chaves e quitação de todos os débitos o valor é resgatado no final do contrato de locação.</p>
			</div>
		</div>

	</div>

	<hr>
	<div class="button mt-40 text-center">        
		<a href="/documentacao-necessaria" use:link replace title="" class="btn btn-secondary">
			Confira a documentação necessária para locação <div class="arrow-animate"><i class="far fa-arrow-right"></i></div> 
		</a>
	</div>

</div>

<style type="text/sass">

.card-border
	padding: 20px
	display: flex
	align-items: center
	flex-direction: column
	h2
		font-size: 16px
	p 
		font-size: 12px
		line-height: 120%

</style>